import firedux from '../firedux'
import {dispatch} from '../store'
import moment from 'moment'

import {
  CONVERSATIONS_PRIVATE_REFS_ENDPOINT,
  SETTINGS_SEGMENTS_ENDPOINT
} from '../../config/constants'

import getUser from '../getters/user'
import setRecentConversations from '../actions/set_recent_conversations'
import setRecentConvUser from '../actions/set_recent_conversation_user'

const getUsers = (uids = []) => uids.forEach((uid) => {
  getUser(uid).then((user) => {
    if (user) dispatch(setRecentConvUser(user))
  })
})

const onData = (snapshot) => {
  if (snapshot.exists()) {
    const convs = snapshot.val()
    dispatch(setRecentConversations(convs))
    getUsers(Object.keys(convs))
  }
}

const onSettings = (uid, snapshot) => {
  if (!snapshot.exists()) return

  const {dayTimeout, numberOfUsers} = snapshot.val()
  const daysAgo = moment().subtract(dayTimeout, 'days').valueOf()

  const ENDPOINT = CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + uid
  const ref = firedux.ref.child(ENDPOINT)
    .orderByChild('latestMessageTime')
    .startAt(daysAgo).limitToLast(numberOfUsers)

  ref.off('value', onData)
  ref.on('value', onData)
}

export const watchRecentConversations = (uid) => {
  const DAY_TIMEOUT_ENDPOINT = SETTINGS_SEGMENTS_ENDPOINT + '/recents'
  firedux.ref.child(DAY_TIMEOUT_ENDPOINT).on('value', onSettings.bind(null, uid))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/recent_conversations.js
 **/